import { BaSeButton, BaSeCheckbox } from '@base/react';
import React from 'react';

export const ColumnFilter = ({
  columnId,
  items,
  setFilter,
  setTags,
  closeFilter,
  fetchData,
  isSearchFor,
  setIsClearFilter,
  setListModels,
  resetSelection
}) => {
  const [columnFilter, setColumnFilter] = React.useState([]);

  function Option({ option, filter, handleChange }) {
    return (
      <div style={{ margin: '16px 0' }}>
        <BaSeCheckbox
          label={option}
          checked={filter.includes(option)}
          onChange={handleChange(option)}
        />
      </div>
    );
  }

  const handleChange = React.useCallback(
    (option) => (checked) =>
      setColumnFilter((filter) => [
        ...filter.filter((i) => i !== option),
        ...(checked ? [option] : []),
      ]),
    [],
  );

  const TagLabel = React.useMemo(
    () => ({
      tipo: 'Template',
    }),
    [],
  );
  return (
    <>
      {items.map((o, i) => (
        <Option
          key={i}
          option={o.id}
          filter={columnFilter}
          handleChange={handleChange}
        />
      ))}
      <BaSeButton
        value="Selecionar"
        onClick={() => {
          setIsClearFilter(false);
          setFilter((actualFilter) => {
            if (!isSearchFor) {
              return fetchData({
                filter: { listaModelos: columnFilter },
                sort: { type: 'DESC', field: 'dataConclusao' },
              });
            }
            return { ...actualFilter, listaModelos: columnFilter };
          });
          setListModels(columnFilter);
          setTags((tagsActive) => {
            return [
              ...tagsActive.filter(
                (tag) => !tag?.label?.startsWith('Template'),
              ),
              {
                label: `${TagLabel[columnId]}: ${columnFilter}`,
                onClose: () => {
                  setTags((tags) => {
                    const tagsFiltered = [
                      ...tags.filter(
                        (tag) => !tag?.label?.startsWith(TagLabel[columnId]),
                      ),
                    ];
                    setIsClearFilter(!tagsFiltered.length);
                    return tagsFiltered;
                  });
                  setListModels('');
                  fetchData({
                    filter: { listaModelos: undefined },
                    sort: { type: 'DESC', field: 'dataConclusao' },
                  });
                  resetSelection()
                },
              },
            ];
          });
          resetSelection()
          closeFilter();
        }}
      />
    </>
  );
};
